import { api } from '@/lib/api/client';
import type { AiReviewList } from './aiReviewTypes';

/**
 * "저점 신호 검토" 조회 API. (2026-10-17 · BACKLOG I-94 · docs/impl/153 23.4)
 *
 * 🔴 조회만 있다 — 국면 · 검토 줄은 장중 배치가 만든다. 화면에서 다시 만들게 하면
 *   마음에 드는 결과가 나올 때까지 다시 돌리고 싶어진다(CLAUDE.md 1.3).
 *
 * @param days 최근 며칠 안에 연 국면(아직 열린 국면은 기간과 상관없이 온다)
 */
export function fetchAiReview(days: number): Promise<AiReviewList> {
  return api.get<AiReviewList>('/trading/ai-review', { days });
}
